import { isMobile } from 'react-device-detect';
import React from 'react';

/**
 * 수평선 - 8픽셀
 */

export default function Hr8() {
  return (
    <div
      style={isMobile ? { height: 8, width: '100%', backgroundColor: 'var(--colGray1)' } : { display: 'none' }}
    ></div>
  );
}
